/**
 * 增删改页面通用mixin
 * 具体使用请参考官方文档：https://cn.vuejs.org/v2/guide/mixins.html
 */
import $ from 'jquery'
import {mapState} from 'vuex'
import qs from 'qs'
import moment from 'moment'

export default {
    data() {
        return {
            searchForm: {},
            pagination: {
                page: 1,
                pageSize: 10,
                total: 0,
            },
            pageSizeList: [10, 20, 50, 100, 200, 500],

            timePickerOptions: {
                disabledDate(time) {
                    return false;
                },
                shortcuts: [{
                    text: '上月',
                    onClick(picker) {
                        let day = new Date();
                        let first = day.setMonth(day.getMonth()-1, 1);
                        day = new Date();
                        let last = day.setMonth(day.getMonth(), 0);
                        picker.$emit('pick', [first, last]);
                    }
                },
                    {
                        text: '本月',
                        onClick(picker) {
                            let day = new Date();
                            let first = day.setMonth(day.getMonth(), 1);
                            let last = day.setMonth(day.getMonth()+1, 0);
                            picker.$emit('pick', [first, last]);
                        }
                    },]
            },

            tabelHeight: null,
            tableData: [],
            loading: false,
            // 编辑窗口数据
            editDialog: {
                width: '700px',
                dialogFormVisible: false,
                form: {},
                editId: null, //当前编辑行标识符ID
                formLabelWidth: '120px',
                isEdit: true, // 是否编辑模式
                requestMethod: 'post', // 请求类型
                isShowDetail: false, //是否只读或禁用
                loading: false //容器加载动画
            },
            detailDialog: {
                width: '700px',
                dialogFormVisible: false,
                form: {},
                formLabelWidth: '120px',
                isShowDetail: false //是否只读或禁用
            },
            addDialog: {
                width: '700px',
                dialogFormVisible: false,
                form: {},
                formLabelWidth: '120px',
                requestMethod: 'post', // 请求类型
            },
            exportBtnDisabled: false, // 导出按钮禁用标识
        }
    },
    mounted() {
        const that = this;
        window.onresize = function () {
            that.tabelHeight = that.getTableHeight()
        };
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            window.onresize()
        })
        //加载表数据
        this.getTableData()
        //延时执行高度计算,避免搜索框高度计算时获取不准确问题
        setTimeout(function () {
            window.onresize()
        }, 600)
        //延时执行高度计算,避免搜索框高度计算时获取不准确问题
        setTimeout(function () {
            window.onresize()
        }, 1000)
    },
    methods: {
        onSubmit() {
            //console.log('submit!');
            this.pagination.page = 1
            this.getTableData()
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pagination.page = val
            this.getTableData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        getTableHeight() {
            if (this.device === 'mobile') {
                //myTabelHeight = $(document.body).height() - $('.search-form').height() - $('.pagination-footer').height() - 90
                return null
            } else {
                let myTabelHeight = $('.d2-theme-container').innerHeight() - $('.d2-theme-container-main-header').outerHeight() - $('.search-form').outerHeight() - $('.pagination-footer').outerHeight() - 50
                if ($('.rule_desc').length > 0) {
                    myTabelHeight = myTabelHeight - $('.rule_desc').outerHeight()
                }
                //console.log(`.d2-theme-container:${$('.d2-theme-container').innerHeight()},.d2-theme-container-main-header:${$('.d2-theme-container-main-header').outerHeight()}`)
                //console.log(`.search-form:${$('.search-form').outerHeight()},.pagination-footer:${$('.pagination-footer').outerHeight()}`)
                //console.log(`.rule_desc:$('.rule_desc').outerHeight()}`)
                //console.log(`表格高度计算结果：${myTabelHeight}`)
                return myTabelHeight
            }
        },
        getPageStart() {
            return (this.pagination.page - 1) * this.pagination.pageSize
        },
        /**
         * 获取表格数据
         */
        formatMonth(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = ('0' + (d.getMonth() + 1)).slice(-2); // 补零
            return `${year}-${month}`;
        },
        getTableData() {
            this.loading = true
            let requestParm = Object.assign(this.searchForm, this.pagination)
             requestParm.month = this.formatMonth(this.searchForm.month);
            // requestParm.startPosition = this.getPageStart()
            // requestParm.maxResult = this.pagination.pageSize
            this.$axios.get(this.tableDataApi, {params: requestParm}).then(res => {
                if (res.code === 200) {
                    console.log("##", this.tableDataApi, res)
                    this.tableData = res.data
                    this.pagination.total = res.total
                    // 页码大于1，并且表格数据返回0长度时，尝试获取前一页数据（修复场景：删除非第一页的最后一条数据后，无法跳转有效数据页）
                    if (this.tableData.length === 0 && this.pagination.page > 1) {
                        this.pagination.page -= 1
                        this.getTableData()
                    }
                }
            }).catch(function (error) {
                console.log(error);
            }).then(() => {
                this.loading = false
            });
        },
        /**
         * 列表字段转义
         * @param row
         * @param column
         * @param cellValue
         * @param index
         * @returns {*}
         */
        formatter(row, column, cellValue, index) {
            return this.codeDic[column.property][cellValue]
        },
        /**
         * 格式化时间戳（单位：毫秒）
         */
        formatterTimestamp(row, column, cellValue, index) {
            if (cellValue) {
                return moment(cellValue).format('YYYY-MM-DD HH:mm:ss')
            } else {
                return ' '
            }
        },
        /**
         * 显示添加窗口(关闭重置，请在dialog中使用close事件处理)
         */
        showAddDialog() {
            //this.addDialog.form = {}
            this.addDialog.title = '新增'
            this.addDialog.dialogFormVisible = true
        },
        /**
         * 显示编辑弹窗
         * @param isEdit 是否编辑模式，默认true
         * @param row
         * @param requestMethod 可选：提交表单时的请求类型，默认为post，优先级低于提交函数updateTableData的requestMethod参数
         */
        showEditDialog(isEdit, row, requestMethod) {
            if (isEdit == null) {
                isEdit = true
            }
            this.editDialog.form = {}
            this.editDialog.title = '新增'
            this.editDialog.isEdit = false
            this.editDialog.requestMethod = requestMethod ? requestMethod : 'post'
            if (isEdit === true) {
                this.editDialog.title = '修改'
                this.editDialog.isEdit = true
                this.editDialog.form = {...row}
                this.editDialog.editId = row.id
            }
            this.editDialog.isShowDetail = false
            this.editDialog.dialogFormVisible = true
        },
        showEditDialogReadOnly(row) {
            this.editDialog.form = {}
            this.editDialog.title = '详情'
            this.editDialog.form = {...row}
            this.editDialog.isShowDetail = true
            this.editDialog.dialogFormVisible = true
        },
        /**
         * 显示详情窗口
         * @param row
         */
        showDetailDialog(row) {
            this.detailDialog.form = {}
            this.detailDialog.title = '详情'
            this.detailDialog.form = {...row}
            this.detailDialog.isShowDetail = true
            this.detailDialog.dialogFormVisible = true
        },
        /**
         * 修改数据提交
         * @param formName 可选参数，传入表单ref名称时，会进行规则校验
         * @param requestMethod 可选参数，默认值为this.editDialog.requestMethod，优先级高于提交函数updateTableData的requestMethod参数
         */
        updateTableData(formName, requestMethod) {
            if (this.$refs[formName]) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.updateTableDataAjax(requestMethod)
                    }
                })
            } else {
                this.updateTableDataAjax(requestMethod)
            }
        },
        /**
         * 确认并调用修改数据接口
         */
        updateTableDataAjax(requestMethod) {
            let requestData = {}
            //指定修改字段时，只拼接指定字段
            if (this.editDialog.apiUpdateFields) {
                let apiUpdateFields = this.editDialog.apiUpdateFields
                for (let i in apiUpdateFields) {
                    requestData[apiUpdateFields[i]] = this.editDialog.form[apiUpdateFields[i]]
                }
            } else {
                requestData = this.editDialog.form
            }
            requestData = {...{id: this.editDialog.editId}, ...requestData}
            this.$axios({
                method: requestMethod ? requestMethod : this.editDialog.requestMethod,
                url: this.editDialog.isEdit ? this.editDialog.updateDataApi : this.addDialog.addDataApi,
                data: requestData,
                //params:requestData
            }).then(res => {
                if (res.code == 200) {
                    /*this.$alert(res.message, '成功提示',{
                        callback: action => {
                            this.editDialog.dialogFormVisible = false
                            this.getTableData()
                        }
                    })*/
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.editDialog.dialogFormVisible = false
                    this.getTableData()
                } else {
                    this.$alert(res.message, '失败提示')
                }
            }).catch(function (error) {
                console.log(error)
            }).then(() => {
                this.loading = false
            });
        },
        /**
         * 新增数据
         * @param formName 可选参数，传入表单ref名称时，会进行规则校验
         * @param requestMethod 可选参数，默认值为this.addDialog.requestMethod，优先级高于提交函数addTableData的requestMethod参数
         */
        addTableData(formName, requestMethod) {
            if (this.$refs[formName]) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addTableDataAjax(requestMethod)
                    }
                })
            } else {
                this.addTableDataAjax(requestMethod)
            }
        },
        /**
         * 确认并调用新增接口
         */
        addTableDataAjax(requestMethod) {
            this.$axios({
                method: requestMethod ? requestMethod : this.addDialog.requestMethod,
                url: this.addDialog.addDataApi,
                data: this.addDialog.form
            }).then(res => {
                if (res.code == 200) {
                    /*this.$alert(res.message, '成功提示',{
                        callback: action => {
                            this.addDialog.dialogFormVisible = false
                            this.getTableData()
                        }
                    })*/
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.addDialog.dialogFormVisible = false
                    this.getTableData()
                } else {
                    this.$alert(res.message, '失败提示')
                }
            }).catch(function (error) {
                console.log(error)
            }).then(() => {
                this.loading = false
            });
        },
        /**
         * 删除指定数据
         * @param row
         * @param requestMethod 可选，默认get
         */
        deleteData(row, requestMethod) {
            let id = row.id
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$axios({
                        method: requestMethod ? requestMethod : 'get',
                        url: this.deleteDataApi,
                        data: {'ids': id},
                        params: {
                            'ids': id
                        }
                    })
                        .then(res => {
                            if (res.code == 200) {
                                /*this.$alert(res.message, '成功提示', {
                                    callback: action => {
                                        this.getTableData()
                                    }
                                })*/
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                })
                                this.getTableData()
                            } else {
                                //this.$message.error(res.message)
                                this.$alert(res.message, '失败提示')
                            }
                        })
                        .catch(res => {
                            //this.$message.error(res.message)
                            this.$alert(res.message, '失败提示')
                        })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        /**
         * 导出文件
         */
        exportFile(searchForm, url) {
            this.exportBtnDisabled = true
            //导出文件
            if (this.pagination.total > 60000) {
                this.$alert('单批次最多导出6万条数据，您超出的部分数据可按条件再次导出！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        //立即启用导出按钮
                        this.exportBtnDisabled = false
                    }
                })
            } else {
                searchForm.startPosition = 0
                searchForm.maxResult = 60000
                let queryParams = qs.stringify(searchForm)
                window.location.href = url + '?' + queryParams
            }
            setTimeout(() => {
                this.exportBtnDisabled = false
            }, 5000)
        }
    },
    computed: {
        ...mapState({
            device: state => state.d2admin.device,
            windowHeight: state => state.d2admin.windowHeight
        }),
        /**
         * 获取编辑窗口的高度（动态运算）
         * @returns {string}
         */
        getEditDialogHeight() {
            return (this.windowHeight - 300) + 'px'
        }
    }
}
